import * as React from 'react';
import './Dashboard.css'
import { Fragment, useState, useEffect } from 'react';
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import logo from "../../logoblanco.webp";

import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import AppBar from '@mui/material/AppBar';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import IconButton from '@mui/material/IconButton';
import BalanceIcon from '@mui/icons-material/Balance';
import SummarizeIcon from '@mui/icons-material/Summarize';
import WorkIcon from '@mui/icons-material/Work';
import AddIcon from '@mui/icons-material/Add';
import PersonIcon from '@mui/icons-material/Person';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import DiscountIcon from '@mui/icons-material/Discount';
import SafetyDividerIcon from '@mui/icons-material/SafetyDivider';
import LocalActivityIcon from '@mui/icons-material/LocalActivity';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import AdbIcon from '@mui/icons-material/Adb';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import Collapse from '@mui/material/Collapse';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import { DialogContent, DialogActions } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import FormHelperText from '@mui/material/FormHelperText';
import TextField from '@mui/material/FormHelperText';
import Assesment from '@mui/icons-material/Assessment';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import ArchiveIcon from '@mui/icons-material/Archive';
import Campaign from '@mui/icons-material/Campaign'
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import Group from '@mui/icons-material/Group';
import ShareIcon from '@mui/icons-material/Share';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from "@mui/material/Grid";
import Popover from '@mui/material/Popover';
import { FormContainer, TextFieldElement, AutocompleteElement, SelectElement, SliderElement } from 'react-hook-form-mui';

import { setUser, logOut, selectCurrentUser } from "../../redux/reducers/authSlice";
import { selectMisContratoById, useGetMisContratosQuery } from "../../redux/reducers/misContratosSlice";
import { selectContratoById, useGetContratosQuery } from "../../redux/reducers/contratosSlice";
import { useGetRolesMapQuery } from "../../redux/reducers/rolesMapSlice";
import { useGetRolesQuery } from "../../redux/reducers/rolesSlice";
import { usePermisosRolesMapQuery, usePermisosQuery } from "../../redux/reducers/permisosSlice";
import { useGetTitularidadContratosQuery } from "../../redux/reducers/titularidadcontratosSlice";
import { useGetPersonasQuery, selectPersonasFisicas, selectPersonasJuridicas } from "../../redux/reducers/personasSlice";
import { setCredentials } from "../../redux/reducers/authSlice";
import { useLoginMutation, useImpersonateMutation } from "../../redux/api/authApiSlice";
import theme from '../../theme.js';

import { apiSlice } from "../../redux/api/apiSlice";
// Prueba animacion
import { motion, useAnimate, usePresence, AnimatePresence } from "framer-motion"

const zfill = (number, width) => {
    var numberOutput = Math.abs(number); /* Valor absoluto del número */
    var length = number.toString().length; /* Largo del número */
    var zero = "0"; /* String de cero */

    if (width <= length) {
        if (number < 0) {
            return ("-" + numberOutput.toString());
        } else {
            return numberOutput.toString();
        }
    } else {
        if (number < 0) {
            return ("-" + (zero.repeat(width - length)) + numberOutput.toString());
        } else {
            return ((zero.repeat(width - length)) + numberOutput.toString());
        }
    }
};

const DashboardPage = () => {
    const [minimized, setMinimized] = React.useState(false);

    const CategoriesMenu = () => {
        const [expandUsersCat, setExpandUsersCat] = React.useState(false);
        const [expandMisContratosCat, setExpandMisContratosCat] = React.useState(true);
        const [expandContratosCat, setExpandContratosCat] = React.useState(true);
        const [expandCobranzasCat, setExpandCobranzasCat] = React.useState(false);

        const currentUser = useSelector(selectCurrentUser);
        const navigate = useNavigate();
        const location = useLocation();
        const pathname = location.pathname.toLowerCase();

        const { data: contratos, isLoading, isSuccess, isError, error } = useGetContratosQuery();
        const { data: titularidades, isLoading: isLoadingTitularidades, isSuccess: isSuccessTitularidades, isError: isErrorTitularidades, error: errorTitularidades } = useGetTitularidadContratosQuery();

        const StdCategory = (props) => {
            const [anchorEl, setAnchorEl] = React.useState({});
            // Function to handle popover open for a specific category
            const handlePopoverOpen = (event, label) => {
                minimized ?
                    setAnchorEl({ [label]: event.currentTarget })
                    : setAnchorEl(anchorEl)
            };

            // Function to handle popover close for a specific category
            const handlePopoverClose = (label) => {
                minimized ?
                    setAnchorEl({ ...anchorEl, [label]: null })
                    : setAnchorEl(anchorEl)
            };
            // Function to check if a popover for a specific category is open
            const isPopoverOpen = (label) => Boolean(anchorEl[label]);
            const { label, path, Icon } = props;
            return (
                <>
                    {<>
                        <ListItem disablePadding onClick={() => navigate(`/dashboard/${path}`)}
                            aria-owns={isPopoverOpen(label) ? 'aria-' + label : undefined}
                            aria-haspopup="true"
                            onMouseEnter={(event) => handlePopoverOpen(event, label)}
                            onMouseLeave={() => handlePopoverClose(label)} >
                            <ListItemButton component={motion.div} whileHover={{ scale: 1.1, transition: { duration: 0.3 } }} whileTap={{ scale: 0.9 }}>
                                <ListItemIcon>
                                    <Icon sx={{ color: `${pathname.startsWith(`/dashboard/${path}`) && minimized ? theme.palette.primary.main : null}` }} />
                                </ListItemIcon>
                                <ListItemText primary={label} sx={{ color: `${pathname.startsWith(`/dashboard/${path}`) ? theme.palette.primary.main : null}` }} />
                            </ListItemButton>
                        </ListItem>
                        <Popover
                            id={'aria-' + label}
                            sx={{
                                pointerEvents: 'none',
                            }}
                            open={isPopoverOpen(label)}
                            anchorEl={anchorEl[label]}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'center',
                            }}
                            transformOrigin={{
                                vertical: 'center',
                                horizontal: 'left',
                            }}
                            onClose={() => handlePopoverClose(label)}
                            disableRestoreFocus
                        >
                            <Typography sx={{ p: 1 }}>{label}</Typography>
                        </Popover>
                    </>}
                </>
            )
        }
        const MisContratosCategory = () => {
            const { data: misContratos, isLoading, isSuccess, isError, error } = useGetMisContratosQuery();
            const navigate = useNavigate();
            const CustomMenuItem = ({ text, onClick, navigatePath, contratoId }) => {
                const navigate = useNavigate();
                let handleItemClick = onClick || (() => navigate(navigatePath || text));
                const [anchorEl, setAnchorEl] = React.useState(null);
                const handlePopoverOpen = (event) => {
                    minimized ?
                        setAnchorEl(event.currentTarget)
                        : setAnchorEl(anchorEl)
                };

                const handlePopoverClose = () => {
                    minimized ?
                        setAnchorEl(null)
                        : setAnchorEl(anchorEl)
                };
                const open = Boolean(anchorEl);
                return (
                    <Fragment>
                        <ListItemButton component={motion.div} whileHover={{ scale: 1.1, transition: { duration: 0.3 } }} whileTap={{ scale: 0.9 }} sx={{ pl: 4 }} onClick={handleItemClick} key={text}
                            aria-owns={open ? "MisContratosPop" + text : undefined}
                            aria-haspopup="true"
                            onMouseEnter={handlePopoverOpen}
                            onMouseLeave={handlePopoverClose}>
                            <ListItemIcon>
                                <SummarizeIcon sx={{ color: `${pathname.startsWith(`/dashboard/miscontratos/${contratoId}`) && minimized ? theme.palette.primary.main : null}` }} />
                            </ListItemIcon>
                            <ListItemText primary={text} sx={{ color: `${pathname.startsWith(`/dashboard/miscontratos/${contratoId}`) ? theme.palette.primary.main : null}` }} />
                        </ListItemButton>
                        <Popover
                            id={"MisContratosPop" + text}
                            sx={{
                                pointerEvents: 'none',
                            }}
                            open={open}
                            anchorEl={anchorEl}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'center',
                            }}
                            transformOrigin={{
                                vertical: 'center',
                                horizontal: 'left',
                            }}
                            onClose={handlePopoverClose}
                            disableRestoreFocus
                        >
                            <Typography sx={{ p: 1 }}>{text}</Typography>
                        </Popover>
                    </Fragment>
                )
            }
            const [anchorEl, setAnchorEl] = React.useState(null);
            const handlePopoverOpen = (event) => {
                minimized ?
                    setAnchorEl(event.currentTarget)
                    : setAnchorEl(anchorEl)
            };

            const handlePopoverClose = () => {
                minimized ?
                    setAnchorEl(null)
                    : setAnchorEl(anchorEl)
            };

            const open = Boolean(anchorEl);
            return (
                <Fragment>
                    <ListItem
                        disablePadding
                        aria-owns={open ? 'mouse-over-popover' : undefined}
                        aria-haspopup="true"
                        onMouseEnter={handlePopoverOpen}
                        onMouseLeave={handlePopoverClose}>
                        <ListItemButton component={motion.div} whileHover={{ scale: 1.1, transition: { duration: 0.3 } }} whileTap={{ scale: 0.9 }} onClick={() => { setExpandMisContratosCat(!expandMisContratosCat); navigate('/dashboard/miscontratos') }}>
                            <ListItemIcon>
                                <WorkIcon sx={{ color: `${pathname.startsWith('/dashboard/miscontratos') && minimized ? theme.palette.primary.main : null}` }} />
                                {minimized ? expandMisContratosCat ? <ExpandLess /> : <ExpandMore /> : null}
                            </ListItemIcon>
                            <ListItemText primary={'Mis Contratos'} sx={{ color: `${pathname === `/dashboard/miscontratos` ? theme.palette.primary.main : null}` }} />
                            {expandMisContratosCat ? <ExpandLess /> : <ExpandMore />}
                        </ListItemButton>
                    </ListItem>
                    <Popover
                        id="MisContratosPop"
                        sx={{
                            pointerEvents: 'none',
                        }}
                        open={open}
                        anchorEl={anchorEl}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                        transformOrigin={{
                            vertical: 'center',
                            horizontal: 'left',
                        }}
                        onClose={handlePopoverClose}
                        disableRestoreFocus
                    >
                        <Typography sx={{ p: 1 }}>Mis Contratos</Typography>
                    </Popover>
                    <Collapse in={expandMisContratosCat} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            {isLoading && <CircularProgress />}
                            {isError && <p>Error cargando contratos</p>}
                            {isSuccess &&
                                // Object.values(misContratos?.entities || {})?.map(x =>
                                //     x.contrato?.fechaPerfeccionamiento === null ? null : <CustomMenuItem text={`${zfill(x.contrato.contratoId, 6)}`} navigatePath={`miscontratos/${x.contrato.contratoId}`} key={x.contrato.contratoId} contratoId={x.contrato.contratoId} />
                                // )
                                Object.values(misContratos?.entities || {})?.map(x => <CustomMenuItem key={`mis-contratos-${x.contrato.contratoId}`} text={`${zfill(x.contrato.contratoId, 6)}`} navigatePath={`miscontratos/${x.contrato.contratoId}`} contratoId={x.contrato.contratoId} />
                                )
                            }
                        </List>
                    </Collapse>
                </Fragment>
            )
        }
        const CobranzasCategories = () => {
            const CustomMenuItem = ({ navigatePath, label }) => {
                const navigate = useNavigate();
                let handleItemClick = (() => navigate(navigatePath));
                const [anchorEl, setAnchorEl] = React.useState(null);

                const handlePopoverOpen = (event) => {
                    minimized ?
                        setAnchorEl(event.currentTarget)
                        : setAnchorEl(anchorEl)
                };

                const handlePopoverClose = () => {
                    minimized ?
                        setAnchorEl(null)
                        : setAnchorEl(anchorEl)
                };

                const open = Boolean(anchorEl);
                return (
                    <Fragment>
                        <ListItemButton component={motion.div} whileHover={{ scale: 1.1, transition: { duration: 0.3 } }} whileTap={{ scale: 0.9 }} sx={{ pl: 4 }}
                            onClick={handleItemClick}
                            key={label}
                            aria-owns={open ? "Contratos" + label : undefined}
                            aria-haspopup="true"
                            onMouseEnter={handlePopoverOpen}
                            onMouseLeave={handlePopoverClose}>
                            <ListItemIcon>
                                {label === 'debito' ? <CreditCardIcon sx={{ color: `${pathname.startsWith('/dashboard/cobranzas/debito') && minimized ? theme.palette.primary.main : null}` }} /> :
                                    label === 'cuenta-recaudadora' ? <ArchiveIcon sx={{ color: `${pathname.startsWith('/dashboard/cobranzas/cuenta-recaudadora') && minimized ? theme.palette.primary.main : null}` }} /> :
                                        <ShareIcon sx={{ color: `${pathname.startsWith('/dashboard/cobranzas/getnet') && minimized ? theme.palette.primary.main : null}` }} />
                                }
                            </ListItemIcon>
                            {label === 'debito' ? <ListItemText primary="Débito Directo" sx={{ color: `${pathname.startsWith('/dashboard/cobranzas/debito') ? theme.palette.primary.main : null}` }} />
                                :
                                label === 'cuenta-recaudadora' ? <ListItemText primary="Cuenta Recaudadora" sx={{ color: `${pathname.startsWith('/dashboard/cobranzas/cuenta-recaudadora') ? theme.palette.primary.main : null}` }} />
                                    :
                                    <ListItemText primary="GetNet" sx={{ color: `${pathname.startsWith('/dashboard/cobranzas/getnet') ? theme.palette.primary.main : null}` }} />

                            }
                        </ListItemButton>
                        <Popover
                            id={"Cobranzas" + label}
                            sx={{
                                pointerEvents: 'none',
                            }}
                            open={open}
                            anchorEl={anchorEl}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'center',
                            }}
                            transformOrigin={{
                                vertical: 'center',
                                horizontal: 'left',
                            }}
                            onClose={handlePopoverClose}
                            disableRestoreFocus
                        >
                            <Typography sx={{ p: 1 }}>{label === 'debito' ? 'Debito' :
                                label === 'cuenta-recaudadora' ? 'Cuenta Recaudadora' :
                                    'GetNet'}</Typography>
                        </Popover>
                    </Fragment>
                )
            }
            const handleClick = () => setExpandCobranzasCat(!expandCobranzasCat);
            const [anchorEl, setAnchorEl] = React.useState(null);
            const handlePopoverOpen = (event) => {
                minimized ?
                    setAnchorEl(event.currentTarget)
                    : setAnchorEl(anchorEl)
            };

            const handlePopoverClose = () => {
                minimized ?
                    setAnchorEl(null)
                    : setAnchorEl(anchorEl)
            };

            const open = Boolean(anchorEl);
            return (
                <Fragment>
                    <ListItem disablePadding
                        aria-owns={open ? 'Cobranzas' : undefined}
                        aria-haspopup="true"
                        onMouseEnter={handlePopoverOpen}
                        onMouseLeave={handlePopoverClose}>
                        <ListItemButton component={motion.div} whileHover={{ scale: 1.1, transition: { duration: 0.3 } }} whileTap={{ scale: 0.9 }} onClick={handleClick}>
                            <ListItemIcon>
                                <AccountBalanceIcon sx={{ color: `${pathname.startsWith('/dashboard/cobranzas') && minimized ? theme.palette.primary.main : null}` }} />
                                {minimized ? expandCobranzasCat ? <ExpandLess /> : <ExpandMore /> : null}
                            </ListItemIcon>
                            <ListItemText primary={'Cobranzas'} />
                            {expandCobranzasCat ? <ExpandLess /> : <ExpandMore />}
                        </ListItemButton>

                    </ListItem>
                    <Popover
                        id="Cobranzas"
                        sx={{
                            pointerEvents: 'none',
                        }}
                        open={open}
                        anchorEl={anchorEl}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                        transformOrigin={{
                            vertical: 'center',
                            horizontal: 'left',
                        }}
                        onClose={handlePopoverClose}
                        disableRestoreFocus
                    >
                        <Typography sx={{ p: 1 }}>Cobranzas</Typography>
                    </Popover>
                    <Collapse in={expandCobranzasCat} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            {['debito', 'cuenta-recaudadora', 'getnet']?.map(x =>
                                <CustomMenuItem
                                    key={`custom-menu-item-${x}`}
                                    navigatePath={`/dashboard/cobranzas/` + x}
                                    label={x} />
                            )}
                        </List>
                    </Collapse>
                </Fragment>
            )
        }
        const UsersCategories = () => {
            const CustomMenuItem = ({ navigatePath, label }) => {
                const navigate = useNavigate();
                let handleItemClick = (() => navigate(navigatePath));
                const [anchorEl, setAnchorEl] = React.useState(null);

                const handlePopoverOpen = (event) => {
                    minimized ?
                        setAnchorEl(event.currentTarget)
                        : setAnchorEl(anchorEl)
                };

                const handlePopoverClose = () => {
                    minimized ?
                        setAnchorEl(null)
                        : setAnchorEl(anchorEl)
                };

                const open = Boolean(anchorEl);
                return (
                    <Fragment>
                        <ListItemButton component={motion.div} whileHover={{ scale: 1.1, transition: { duration: 0.3 } }} whileTap={{ scale: 0.9 }} sx={{ pl: 4 }}
                            onClick={handleItemClick}
                            key={label}
                            aria-owns={open ? "Personas" + label : undefined}
                            aria-haspopup="true"
                            onMouseEnter={handlePopoverOpen}
                            onMouseLeave={handlePopoverClose}>
                            <ListItemIcon>
                                {label === 'Humanas' ? <PersonIcon sx={{ color: `${pathname.startsWith('/dashboard/personas/humanas') && minimized ? theme.palette.primary.main : null}` }} />
                                    : <BalanceIcon sx={{ color: `${pathname.startsWith('/dashboard/personas/juridicas') && minimized ? theme.palette.primary.main : null}` }} />}
                            </ListItemIcon>
                            {label === 'Humanas' ? <ListItemText primary="Personas Humanas" sx={{ color: `${pathname.startsWith('/dashboard/personas/humanas') ? theme.palette.primary.main : null}` }} />
                                :
                                <ListItemText primary="Personas Jurídicas" sx={{ color: `${pathname.startsWith('/dashboard/personas/juridicas') ? theme.palette.primary.main : null}` }} />}
                        </ListItemButton>
                        <Popover
                            id={"Cobranzas" + label}
                            sx={{
                                pointerEvents: 'none',
                            }}
                            open={open}
                            anchorEl={anchorEl}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'center',
                            }}
                            transformOrigin={{
                                vertical: 'center',
                                horizontal: 'left',
                            }}
                            onClose={handlePopoverClose}
                            disableRestoreFocus
                        >
                            <Typography sx={{ p: 1 }}>{label === 'Humanas' ? 'Personas Humanas' : 'Personas Juridicas'}</Typography>
                        </Popover>
                    </Fragment>
                )
            }
            const handleClick = () => setExpandUsersCat(!expandUsersCat);
            const [anchorEl, setAnchorEl] = React.useState(null);
            const handlePopoverOpen = (event) => {
                minimized ?
                    setAnchorEl(event.currentTarget)
                    : setAnchorEl(anchorEl)
            };

            const handlePopoverClose = () => {
                minimized ?
                    setAnchorEl(null)
                    : setAnchorEl(anchorEl)
            };

            const open = Boolean(anchorEl);
            return (
                <Fragment>
                    <ListItem disablePadding
                        aria-owns={open ? 'Personas' : undefined}
                        aria-haspopup="true"
                        onMouseEnter={handlePopoverOpen}
                        onMouseLeave={handlePopoverClose}>
                        <ListItemButton component={motion.div} whileHover={{ scale: 1.1, transition: { duration: 0.3 } }} whileTap={{ scale: 0.9 }} onClick={handleClick}>
                            <ListItemIcon>
                                <Group sx={{ color: `${pathname.startsWith('/dashboard/personas') && minimized ? theme.palette.primary.main : null}` }} />
                                {minimized ? expandUsersCat ? <ExpandLess /> : <ExpandMore /> : null}
                            </ListItemIcon>
                            <ListItemText primary={'Personas'} />
                            {expandUsersCat ? <ExpandLess /> : <ExpandMore />}
                        </ListItemButton>

                    </ListItem>
                    <Popover
                        id="Personas"
                        sx={{
                            pointerEvents: 'none',
                        }}
                        open={open}
                        anchorEl={anchorEl}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                        transformOrigin={{
                            vertical: 'center',
                            horizontal: 'left',
                        }}
                        onClose={handlePopoverClose}
                        disableRestoreFocus
                    >
                        <Typography sx={{ p: 1 }}>Personas</Typography>
                    </Popover>
                    <Collapse in={expandUsersCat} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            {['Humanas', 'Juridicas']?.map(x =>
                                <CustomMenuItem
                                    key={`custom-menu-item-${x}`}
                                    navigatePath={`/dashboard/Personas/` + x}
                                    label={x} />
                            )}
                        </List>
                    </Collapse>
                </Fragment>
            )
        }
        const ContratosCategory = () => {
            const navigate = useNavigate();
            const CustomMenuItem = ({ label, navigatePath, Icon, sideBar }) => {
                const navigate = useNavigate();
                let handleItemClick = (() => { navigate(navigatePath || label); setMinimized(sideBar) });
                const [anchorEl, setAnchorEl] = React.useState(null);
                const handlePopoverOpen = (event) => {
                    minimized ?
                        setAnchorEl(event.currentTarget)
                        : setAnchorEl(anchorEl)
                };

                const handlePopoverClose = () => {
                    minimized ?
                        setAnchorEl(null)
                        : setAnchorEl(anchorEl)
                };
                const open = Boolean(anchorEl);
                return (
                    <Fragment>
                        <ListItemButton component={motion.div} whileHover={{ scale: 1.1, transition: { duration: 0.3 } }} whileTap={{ scale: 0.9 }} sx={{ pl: 4 }} onClick={handleItemClick} key={label}
                            aria-owns={open ? "MisContratosPop" + label : undefined}
                            aria-haspopup="true"
                            onMouseEnter={handlePopoverOpen}
                            onMouseLeave={handlePopoverClose}>
                            <ListItemIcon>
                                <Icon sx={{ color: `${pathname === (navigatePath) && minimized ? theme.palette.primary.main : null}` }} />
                            </ListItemIcon>
                            <ListItemText primary={label} sx={{ color: `${pathname === (navigatePath) ? theme.palette.primary.main : null}` }} />
                        </ListItemButton>
                        <Popover
                            id={"ContratosPop" + label}
                            sx={{
                                pointerEvents: 'none',
                            }}
                            open={open}
                            anchorEl={anchorEl}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'center',
                            }}
                            transformOrigin={{
                                vertical: 'center',
                                horizontal: 'left',
                            }}
                            onClose={handlePopoverClose}
                            disableRestoreFocus
                        >
                            <Typography sx={{ p: 1 }}>{label}</Typography>
                        </Popover>
                    </Fragment>
                )
            };
            const [anchorEl, setAnchorEl] = React.useState(null);
            const handlePopoverOpen = (event) => {
                minimized ?
                    setAnchorEl(event.currentTarget)
                    : setAnchorEl(anchorEl)
            };

            const handlePopoverClose = () => {
                minimized ?
                    setAnchorEl(null)
                    : setAnchorEl(anchorEl)
            };
            const categories = [
                {
                    path: '',
                    permisos: 'readContratos',
                    label: 'Contratos',
                    icon: SummarizeIcon,
                    sideBar: minimized
                },
                {
                    path: 'crear-contratos',
                    permisos: 'createContrato',
                    label: 'Crear Contrato',
                    icon: AddIcon,
                    sideBar: true
                },
                {
                    path: 'cupones',
                    permisos: 'createCuponPago',
                    label: 'Cupones',
                    icon: LocalActivityIcon,
                    sideBar: minimized
                },
                {
                    path: 'titularidades',
                    permisos: 'readPersonas',
                    label: 'Titularidades',
                    icon: SafetyDividerIcon,
                    sideBar: minimized
                },

            ]
            const open = Boolean(anchorEl);
            return (
                <Fragment>
                    <ListItem disablePadding
                        aria-owns={open ? 'mouse-over-popover' : undefined}
                        aria-haspopup="true"
                        onMouseEnter={handlePopoverOpen}
                        onMouseLeave={handlePopoverClose}>
                        <ListItemButton component={motion.div} whileHover={{ scale: 1.1, transition: { duration: 0.3 } }} whileTap={{ scale: 0.9 }} onClick={() => { setExpandContratosCat(!expandContratosCat) }}>
                            <ListItemIcon>
                                <SummarizeIcon sx={{ color: `${pathname.startsWith('/dashboard/contratos/') && minimized ? theme.palette.primary.main : null}` }} />
                                {minimized ? expandContratosCat ? <><IconButton onClick={() => { setExpandContratosCat(!expandContratosCat) }} children={<ExpandLess />} /> </> : <><IconButton onClick={() => { setExpandContratosCat(!expandContratosCat) }} children={<ExpandMore />} /> </> : null}
                            </ListItemIcon>
                            <ListItemText primary={'Contratos'} sx={{ color: `${pathname === `/dashboard/contratos/` ? theme.palette.primary.main : null}` }} />
                            {expandContratosCat ? <><IconButton onClick={() => { setExpandContratosCat(!expandContratosCat) }} children={<ExpandLess />} /> </> : <><IconButton onClick={() => { setExpandContratosCat(!expandContratosCat) }} children={<ExpandMore />} /> </>}
                        </ListItemButton>
                    </ListItem>
                    <Popover
                        id="ContratosPop"
                        sx={{
                            pointerEvents: 'none',
                        }}
                        open={open}
                        anchorEl={anchorEl}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                        transformOrigin={{
                            vertical: 'center',
                            horizontal: 'left',
                        }}
                        onClose={handlePopoverClose}
                        disableRestoreFocus
                    >
                        <Typography sx={{ p: 1 }}>Contratos</Typography>
                    </Popover>
                    <Collapse in={expandContratosCat} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            {categories?.map(x =>
                                currentUser?.permisos?.includes(x.permisos) ?
                                    <CustomMenuItem
                                        key={`custom-menu-item-${x.path}`}
                                        navigatePath={`/dashboard/contratos/` + x.path}
                                        label={x.label}
                                        Icon={x.icon}
                                        sideBar={x.sideBar} /> : null

                            )}
                        </List>
                    </Collapse>
                </Fragment>
            )
        }
        return (<Box sx={{ overflow: 'auto', backgroundColor: '#f7f7f7', height: '100%' }}>
            <List>
                <MisContratosCategory></MisContratosCategory>
                {/* <StdCategory label={'Calculadora'} path={'calculadora'} Icon={KeyboardIcon}></StdCategory> */}
                <StdCategory label={'Licitaciones'} path={'licitaciones'} Icon={EmojiEventsIcon}></StdCategory>
            </List>
            <Divider />
            <List>
                {currentUser?.roles?.find(rol => rol.toLowerCase() !== "ahorrista") ?
                    <Fragment>
                        <UsersCategories />
                        {currentUser?.permisos?.includes('readContratos') ?
                            <ContratosCategory />
                            : null
                        }
                        {/* {currentUser?.permisos?.includes('readContratos') ?
                            <StdCategory label={'Contratos'} path={'contratos'} Icon={SummarizeIcon}></StdCategory>
                            : null
                        } */}
                        {/* {currentUser?.permisos?.includes('readContratos') ?
                            <StdCategory label={'Titularidades'} path={'titularidades'} Icon={SafetyDividerIcon}></StdCategory>
                            : null
                        } */}
                        {/* <StdCategory label={'Contratos'} path={'contratos'} Icon={SummarizeIcon}></StdCategory>
                        <StdCategory label={'Comisiones'} path={'comisiones'} Icon={DiscountIcon}></StdCategory> */}
                        {/* {currentUser?.permisos?.includes('readPagos') ?
                            <StdCategory label={'Cupones'} path={'cupones'} Icon={LocalActivityIcon} ></StdCategory>
                            : null
                        } */}
                        {currentUser?.permisos?.includes('readPagos') ?
                            <StdCategory label={'Pagos'} path={'pagos'} Icon={CurrencyExchangeIcon} ></StdCategory>
                            : null
                        }
                        {currentUser?.permisos?.includes('readCACs') ?
                            <StdCategory label={'Índices'} path={'indices'} Icon={Assesment}></StdCategory>
                            : null
                        }
                        {/* <StdCategory label={'Edificios'} path={'edificios'} Icon={Apartment}></StdCategory>
                        <StdCategory label={'Eventos de Adjudicación'} path={'eventosadjudicacion'} Icon={EventAvailable}></StdCategory> */}
                        {/* <StdCategory label={'Cobranzas'} path={'cobranzas'} Icon={AccountBalanceIcon}></StdCategory> */}
                        {currentUser?.permisos?.includes('readCobranzas') ?
                            <CobranzasCategories />
                            : null
                        }
                        {currentUser?.permisos?.includes('writeGerenciaEmpresa') ?
                            <StdCategory label={'Roles'} path={'roles'} Icon={VpnKeyIcon}></StdCategory>
                            : null
                        }
                        {<StdCategory label={'Noticias'} path={'noticias'} Icon={Campaign}></StdCategory>}
                       
                        {currentUser?.permisos?.includes('readContratos') ?
                            <StdCategory label={'Comisiones'} path={'comisiones'} Icon={CurrencyExchangeIcon}  ></StdCategory>
                            : null
                        }
                    </Fragment>
                    : null}
            </List>
        </Box>)
    };
    const TopBar = () => {

        const dispatch = useDispatch();
        const currentUser = useSelector(selectCurrentUser);
        const [profileModal, setProfileModal] = React.useState(false);
        const [logearmeComo, setLogearmeComo] = React.useState(false);
        const { data: personas } = useGetPersonasQuery();
        const Bar = () => {
            const [anchorElNav, setAnchorElNav] = React.useState(null);
            const [anchorElUser, setAnchorElUser] = React.useState(null);

            const handleOpenNavMenu = (event) => setAnchorElNav(event.currentTarget);
            const handleOpenUserMenu = (event) => setAnchorElUser(event.currentTarget);
            const handleCloseNavMenu = () => setAnchorElNav(null);
            const handleCloseUserMenu = (e, cb) => {
                setAnchorElUser(null);
                return cb ? cb() : null;
            };

            return (
                <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, width: '100%', left: 0 }}>
                    {/* Desktop Version */}
                    <Toolbar sx={{ flexGrow: 1, display: { xs: 'none', sm: 'none', md: 'flex', lg: 'flex', xl: 'flex', } }}>
                        {/* Logo */}
                        <img src={logo} alt="Logo" style={{ position: 'absolute', margin: '1rem' }} width={'104.2px'} height={'32.875px'} />
                        {/* Perfil */}
                        <Box style={{ position: 'absolute', marginTop: '15px', top: '0px', right: '20px' }} >
                            <IconButton component={motion.div} whileHover={{ scale: 1.1, transition: { duration: 0.3 } }} whileTap={{ scale: 0.9 }} sx={{ p: 0 }} onClick={handleOpenUserMenu}>
                                <Avatar alt={`${currentUser?.nombre}`} src="/static/images/avatar/2.jpg" />
                            </IconButton>
                        </Box>
                    </Toolbar>
                    {/* Mobile Version */}
                    <Toolbar sx={{ flexGrow: 1, display: { xs: 'flex', sm: 'flex', md: 'none', lg: 'none', xl: 'none' } }}>
                        {/* Menu hamburguesa */}
                        <Box sx={{ flexGrow: 1, display: 'flex' }}>
                            <IconButton component={motion.div} whileHover={{ scale: 1.1, transition: { duration: 0.3 } }} whileTap={{ scale: 0.9 }} size="large" onClick={handleOpenNavMenu} color="inherit"  >
                                <MenuIcon />
                            </IconButton>
                            <Menu
                                id="menu-appbar"
                                anchorEl={anchorElNav}
                                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                                keepMounted
                                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                                open={Boolean(anchorElNav)}
                                onClose={handleCloseNavMenu}
                            >
                                <CategoriesMenu></CategoriesMenu>
                            </Menu>
                        </Box>
                        {/* Logo */}
                        <img src={logo} alt="Logo" style={{ position: 'absolute', left: '50%', transform: 'translate(-50%) ' }} width={'104.2px'} height={'32.875px'} />
                        {/* Perfil */}
                        <Box sx={{ flexGrow: 0 }}>
                            <Tooltip title="Open settings">
                                <IconButton component={motion.div} whileHover={{ scale: 1.1, transition: { duration: 0.3 } }} whileTap={{ scale: 0.9 }} onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                                    <Avatar alt={`${currentUser?.nombre}`} src="/static/images/avatar/2.jpg" />
                                </IconButton>
                            </Tooltip>
                            <Menu
                                sx={{ mt: '45px' }}
                                id="menu-appbar"
                                anchorEl={anchorElUser}
                                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                                keepMounted
                                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                                open={Boolean(anchorElUser)}
                                onClose={handleCloseUserMenu}
                            >
                                <MenuItem onClick={(e) => handleCloseUserMenu(e, () => setProfileModal(true))}>
                                    <Typography textAlign="center">Mi Perfil</Typography>
                                </MenuItem>
                                {currentUser?.permisos?.includes('loginAs') ?
                                    <MenuItem onClick={(e) => handleCloseUserMenu(e, () => setLogearmeComo(true))}>
                                        <Typography textAlign="center">Logearme como</Typography>
                                    </MenuItem>
                                    : null}
                                <MenuItem onClick={(e) => handleCloseUserMenu(e, () => {
                                    dispatch(apiSlice.util.resetApiState());
                                    dispatch(logOut())
                                })}>
                                    <Typography textAlign="center">Salir</Typography>
                                </MenuItem>

                            </Menu>
                        </Box>
                    </Toolbar>
                </AppBar>)
        };

        const LogearmeComo = () => {
            const closeForm = () => setLogearmeComo(false);
            const [personaId, setPersonaId] = React.useState(null);
            const [setImpersonate] = useImpersonateMutation();
            const { data: rolesMap } = useGetRolesMapQuery();
            const { data: roles } = useGetRolesQuery();
            const { data: permisosRoles } = usePermisosRolesMapQuery();
            const { data: permisos } = usePermisosQuery()
            const LogearmeComoForm = () => {
                const getDropdownOptions = (allPersonas) => {
                    const getLabel = (option) => {
                        let personaRoles = Object.values(rolesMap?.entities || [])?.filter(r => r.personaId === option.personaId)

                        personaRoles?.length > 1 ?
                            personaRoles = personaRoles?.map((pr, i) => Object.values(roles?.entities || [])?.find(r => r.rolId === pr.rolId)?.nombre || '')?.join(', ') :
                            personaRoles = personaRoles?.map(pr => Object.values(roles?.entities || [])?.find(r => r.rolId === pr.rolId)?.nombre)
                        if (option.personaFisica) {
                            if (!option.nombre && !option.apellido && !option.numeroDocumento) return option.email;
                            return option.nombre + ' ' + option.apellido + ' - ' + option.numeroDocumento + ' - (' + personaRoles + ')';
                        } else {
                            if (!option.denominacionSocial && !option.cuit) return option.email;
                            return option.denominacionSocial + ' - ' + option.cuit + ' - (' + personaRoles + ')';
                        }
                    }
                    let personasAsArray = Object.values(personas?.entities || []);
                    let personasNo = Object.values(rolesMap?.entities || [])
                    if (!allPersonas) {
                        personasAsArray = personasAsArray.filter(p => p.personaFisica);
                    }
                    switch (currentUser?.roles[0]) {
                        case 'Socio':
                            personasNo = personasNo.filter(r => r.rolId < 1).map(m => m.personaId);
                            personasAsArray = personasAsArray.filter(p => !(personasNo.includes(p.personaId)));
                            break
                        case 'Gerente':
                            personasNo = personasNo.filter(r => r.rolId < 2).map(m => m.personaId);
                            personasAsArray = personasAsArray.filter(p => !(personasNo.includes(p.personaId)));
                            break
                        case 'Administrativo':
                            personasNo = personasNo.filter(r => r.rolId < 3).map(m => m.personaId);
                            personasAsArray = personasAsArray.filter(p => !(personasNo.includes(p.personaId)));
                            break
                        case 'Jefe Vendedores':
                            personasNo = personasNo.filter(r => r.rolId < 5).map(m => m.personaId);
                            personasAsArray = personasAsArray.filter(p => !(personasNo.includes(p.personaId)));
                            break
                        case 'Ejecutivo de Cuentas':
                            personasNo = personasNo.filter(r => r.rolId < 6).map(m => m.personaId);
                            personasAsArray = personasAsArray.filter(p => !(personasNo.includes(p.personaId)));
                            break
                        case 'Administrador de Cartera':
                            personasNo = personasNo.filter(r => r.rolId < 7).map(m => m.personaId);
                            personasAsArray = personasAsArray.filter(p => !(personasNo.includes(p.personaId)));
                            break
                        case 'Vendedor Externo':
                            personasNo = personasNo.filter(r => r.rolId < 8).map(m => m.personaId);
                            personasAsArray = personasAsArray.filter(p => !(personasNo.includes(p.personaId)));
                            break
                        case 'Auditor':
                            personasNo = personasNo.filter(r => r.rolId < 9).map(m => m.personaId);
                            personasAsArray = personasAsArray.filter(p => !(personasNo.includes(p.personaId)));
                            break
                        default:
                            break
                    }

                    return personasAsArray.map(p => ({ id: p.personaId, label: getLabel(p) }));
                };
                const filterRoles = (impersonateRoles) => {
                    let rolesFiltrados = []
                    impersonateRoles = impersonateRoles.map(i => Object.values(roles?.entities || []).find(r => r.nombre === i))
                    switch (currentUser?.roles[0]) {
                        case 'Admin':
                            rolesFiltrados = impersonateRoles
                            break
                        case 'Socio':
                            rolesFiltrados = impersonateRoles.filter(r => r.rolId > 1)
                            break
                        case 'Gerente':
                            rolesFiltrados = impersonateRoles.filter(r => r.rolId > 2)
                            break
                        case 'Auditor':
                            rolesFiltrados = impersonateRoles.filter(r => r.rolId > 9)
                            break
                        case 'Administrativo':
                            rolesFiltrados = impersonateRoles.filter(r => r.rolId > 3)
                            break
                        case 'Jefe Vendedores':
                            rolesFiltrados = impersonateRoles.filter(r => r.rolId > 5)
                            break
                        case 'Administrador de Cartera':
                            rolesFiltrados = impersonateRoles.filter(r => r.rolId > 7)
                            break
                        case 'Ejecutivo de Cuentas':
                            rolesFiltrados = impersonateRoles.filter(r => r.rolId > 6)
                            break
                        case 'Vendedor Externo':
                            rolesFiltrados = impersonateRoles.filter(r => r.rolId > 8)
                            break
                        default:

                            break
                    }
                    return rolesFiltrados.map(r => r.nombre)
                }
                const filterPermisos = (rolesFiltrados, permisosFiltrar) => {
                    let permisosIds = []
                    rolesFiltrados?.forEach(rf => {
                        let rol = Object.values(roles?.entities || [])?.find(r => r.nombre === rf)
                        permisosRoles?.filter(pr => pr.rolId === rol.rolId)?.forEach(p => permisosIds.push(p.permisoId))
                    })
                    let permisosFinales = permisos.filter(p => permisosIds.includes(p.permisoId))?.map(p => p.nombre)
                    return permisosFinales
                };
                const dispatch = useDispatch();
                const navigate = useNavigate();
                const [impersonate] = useImpersonateMutation()
                const submit = async (persona) => {
                    if (persona) {
                        try {
                            const impersonaterRes = await setImpersonate(persona.personaId.id).unwrap();
                            //  dispatch(apiSlice.util.resetApiState());
                            // dispatch(setCredentials({ accessToken: impersonaterRes.impersonatedUser.jwt, user: { ...impersonaterRes.impersonatedUser.persona, roles: impersonaterRes.impersonatedUser.roles, permisos: impersonaterRes.impersonatedUser.permisos } }));

                            // navigate('/dashboard/miscontratos');
                            // closeForm();
                            // Impersonate the selected user
                            const credentials = {
                                accessToken: impersonaterRes.impersonatedUser.jwt,
                                user: { ...impersonaterRes.impersonatedUser.persona, roles: impersonaterRes.impersonatedUser.roles, permisos: impersonaterRes.impersonatedUser.permisos }
                            };
                            //Open a new tab with the specified URL for the original user
                            const originalUserTab = window.open('/redirect/' + encodeURI(JSON.stringify(credentials)), '_blank', 'incognito=yes');
                            closeForm();
                        } catch (err) {
                            console.error(err);
                        }
                    }
                }
                return (
                    <Dialog fullWidth minWidth="md" maxWidth='md' onClose={closeForm} open={logearmeComo}>
                        <DialogTitle fontWeight={700} style={{ backgroundColor: theme.palette.success.main, color: 'white' }}>Logearme Como:</DialogTitle>
                        <FormContainer defaultValues={{}} onSuccess={submit}>
                            <DialogContent dividers>
                                <Grid container spacing={0}>
                                    <Grid item xs={12} style={{ 'padding-top': '20px' }}>
                                        <AutocompleteElement
                                            name='personaId'
                                            label='Persona'
                                            value={personaId}
                                            onChange={e => setPersonaId(e.target.value)}
                                            options={getDropdownOptions()}
                                            sx={{ width: '100%', padding: '10px' }}
                                        />
                                    </Grid>

                                </Grid>
                            </DialogContent>
                            <DialogActions style={{ 'padding-top': '20px' }}>
                                <Button component={motion.div} whileHover={{ scale: 1.1, transition: { duration: 0.3 } }} whileTap={{ scale: 0.9 }} variant="outlined" sx={{ fontWeight: "bold" }} onClick={closeForm}>{"Cancelar"}</Button>
                                <Button variant="contained" type='submit' sx={{ marginRight: '5px', fontWeight: "bold", color: "white" }}>{"Aceptar"}</Button>
                            </DialogActions>
                        </FormContainer>
                    </Dialog >
                )
            }


            return (
                <Dialog onClose={closeForm} open={logearmeComo}>
                    <DialogTitle fontWeight={700} style={{ backgroundColor: theme.palette.success.main, color: 'white' }}>Logearme como</DialogTitle>
                    <DialogContent>
                        <LogearmeComoForm />
                    </DialogContent>
                </Dialog>
            )
        };

        const ProfileModal = () => {
            const closeForm = () => setProfileModal(false);

            const MisDatosForm = () => {
                return (<Box sx={{ display: 'flex', flexWrap: 'wrap' }} >
                    {
                        currentUser?.personaFisica ?
                            <div>
                                < FormControl sx={{ m: 1 }
                                } variant="outlined" >
                                    <FormHelperText >Nombre</FormHelperText>
                                    <OutlinedInput readOnly={true} defaultValue={currentUser?.nombre} />
                                </FormControl >
                                <FormControl sx={{ m: 1 }} variant="outlined" >
                                    <FormHelperText >Apellido</FormHelperText>
                                    <OutlinedInput readOnly={true} defaultValue={currentUser?.apellido} />
                                </FormControl>
                                <FormControl sx={{ m: 1 }} variant="outlined" >
                                    <FormHelperText >Email</FormHelperText>
                                    <OutlinedInput readOnly={true} defaultValue={currentUser?.email} />
                                </FormControl>
                                <FormControl sx={{ m: 1 }} variant="outlined" >
                                    <FormHelperText >Numero Documento</FormHelperText>
                                    <OutlinedInput readOnly={true} defaultValue={currentUser?.numeroDocumento} />
                                </FormControl>
                                <FormControl sx={{ m: 1 }} variant="outlined" >
                                    <FormHelperText >Teléfono</FormHelperText>
                                    <OutlinedInput readOnly={true} defaultValue={currentUser?.telefono1} />
                                </FormControl>
                                <FormControl sx={{ m: 1 }} variant="outlined" >
                                    <FormHelperText >Rol</FormHelperText>
                                    <OutlinedInput readOnly={true} defaultValue={currentUser?.roles[0]} />
                                </FormControl>
                                <FormControl sx={{ m: 1 }} variant="outlined" >
                                    <FormHelperText >CUIT/CUIL</FormHelperText>
                                    <OutlinedInput readOnly={true} defaultValue={currentUser?.cuit} />
                                </FormControl>
                            </div > :
                            <div>
                                <FormControl sx={{ m: 1 }} variant="outlined" >
                                    <FormHelperText >Denominación Social</FormHelperText>
                                    <OutlinedInput readOnly={true} defaultValue={currentUser?.denominacionSocial} />
                                </FormControl>
                                <FormControl sx={{ m: 1 }} variant="outlined" >
                                    <FormHelperText >Nomber Fantasía</FormHelperText>
                                    <OutlinedInput readOnly={true} defaultValue={currentUser?.nombreFantasia} />
                                </FormControl>
                                <FormControl sx={{ m: 1 }} variant="outlined" >
                                    <FormHelperText >Email</FormHelperText>
                                    <OutlinedInput readOnly={true} defaultValue={currentUser?.email} />
                                </FormControl>
                                <FormControl sx={{ m: 1 }} variant="outlined" >
                                    <FormHelperText >Numero Documento</FormHelperText>
                                    <OutlinedInput readOnly={true} defaultValue={currentUser?.numeroDocumento} />
                                </FormControl>
                                <FormControl sx={{ m: 1 }} variant="outlined" >
                                    <FormHelperText >Teléfono</FormHelperText>
                                    <OutlinedInput readOnly={true} defaultValue={currentUser?.telefono1} />
                                </FormControl>
                                <FormControl sx={{ m: 1 }} variant="outlined" >
                                    <FormHelperText >Rol</FormHelperText>
                                    <OutlinedInput readOnly={true} defaultValue={currentUser?.roles[0]?.nombre} />
                                </FormControl>
                                <FormControl sx={{ m: 1 }} variant="outlined" >
                                    <FormHelperText >CUIT/CUIL</FormHelperText>
                                    <OutlinedInput readOnly={true} defaultValue={currentUser?.cuit} />
                                </FormControl>
                            </div>}

                </Box >)
            }

            return (
                <Dialog onClose={closeForm} open={profileModal}>
                    <DialogTitle fontWeight={700} style={{ backgroundColor: theme.palette.success.main, color: 'white' }}>Mis Datos: </DialogTitle>
                    <DialogContent dividers>
                        <MisDatosForm></MisDatosForm>
                    </DialogContent>
                    <DialogActions display="flex" justifyContent="flex-end">
                        <Button component={motion.div} whileHover={{ scale: 1.1, transition: { duration: 0.3 } }} whileTap={{ scale: 0.9 }} variant="outlined" sx={{ fontWeight: "bold" }} onClick={closeForm}>{"Volver"}</Button>
                    </DialogActions>
                </Dialog>
            )
        };

        return (
            <Fragment>
                <Bar></Bar>
                {profileModal ? <ProfileModal></ProfileModal> : null}
                {logearmeComo ? <LogearmeComo></LogearmeComo> : null}
            </Fragment>

        )
    };
    const SideBar = () => {
        const maximizedWidth = '18rem';
        const minimizedWidth = '4.5rem';

        const location = useLocation();
        const pathname = location.pathname.toLowerCase();

        const collapseIconParams = {
            sx: { width: '2.5rem', height: '2.5rem', backgroundColor: '#fffffff0', borderRadius: '2rem', padding: '.3rem', boxShadow: '#80808029 1px 1px 2px 2px', border: 'solid 3px #83d67d' },
            onClick: e => setMinimized(!minimized)
        }
        return (
            <>
                <Button component={motion.div} whileHover={{ scale: 1.1, transition: { duration: 0.3 } }} whileTap={{ scale: 0.9 }} sx={{ position: 'fixed', top: '90vh', left: minimized ? '2.5rem' : '16.0rem', zIndex: 1299 }}>
                    {minimized ? <ArrowForwardIosIcon {...collapseIconParams} /> : <ArrowBackIosNewIcon {...collapseIconParams} />}
                </Button>
                <Drawer variant="permanent" className='myDrawer' sx={{ width: minimized ? minimizedWidth : maximizedWidth, [`& .MuiDrawer-paper`]: { width: minimized ? minimizedWidth : maximizedWidth, boxSizing: 'border-box' } }} >
                    <Toolbar />
                    <CategoriesMenu />
                </Drawer>
            </>
        )
    };
    const Content = () => {
        return (<Box component="main" sx={{ flexGrow: 1, p: 3, pt: '5rem' }}>
            <Outlet />
        </Box>)
    };

    return (
        <Box sx={{ display: 'flex' }}>
            <CssBaseline />
            <TopBar />
            <SideBar></SideBar>
            <Content></Content>
        </Box>
    );
}

export default DashboardPage